"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiAnnouncements {
    static getAnnouncementsForEmployee(token) {
        let url = `/announcements`;
        return Client_1.default.httpGet(url, token);
    }
    // All current and future announcements, for admin use
    static getAllAnnouncements(token) {
        let url = `/announcements/all`;
        return Client_1.default.httpGet(url, token);
    }
    static getAnnouncement(token, id) {
        let url = `/announcements/${id}`;
        return Client_1.default.httpGet(url, token);
    }
    // Returns an empty Ok
    static upsertAnnouncement(token, body) {
        let url = `/announcements/upsert`;
        return Client_1.default.httpPost(url, token, body);
    }
    // Returns an empty Ok
    static deleteAnnouncement(token, id) {
        let url = `/announcements/${id}`;
        return Client_1.default.httpDelete(url, token, {});
    }
    static getLocations(token) {
        let url = `/announcements/locations`;
        return Client_1.default.httpGet(url, token);
    }
    static getDepartments(token) {
        let url = `/announcements/departments`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiAnnouncements;
